var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Color Selection ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        width: "300"
                      },
                      model: {
                        value: _vm.dialogColorPrimary,
                        callback: function callback($$v) {
                          _vm.dialogColorPrimary = $$v
                        },
                        expression: "dialogColorPrimary"
                      }
                    },
                    [
                      _c("v-color-picker", {
                        attrs: {
                          mode: "hexa"
                        },
                        model: {
                          value: _vm.colorPrimary,
                          callback: function callback($$v) {
                            _vm.colorPrimary = $$v
                          },
                          expression: "colorPrimary"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        width: "300"
                      },
                      model: {
                        value: _vm.dialogColorSecondary,
                        callback: function callback($$v) {
                          _vm.dialogColorSecondary = $$v
                        },
                        expression: "dialogColorSecondary"
                      }
                    },
                    [
                      _c("v-color-picker", {
                        attrs: {
                          mode: "hexa"
                        },
                        model: {
                          value: _vm.colorSecondary,
                          callback: function callback($$v) {
                            _vm.colorSecondary = $$v
                          },
                          expression: "colorSecondary"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        width: "300"
                      },
                      model: {
                        value: _vm.dialogColorLink,
                        callback: function callback($$v) {
                          _vm.dialogColorLink = $$v
                        },
                        expression: "dialogColorLink"
                      }
                    },
                    [
                      _c("v-color-picker", {
                        attrs: {
                          mode: "hexa"
                        },
                        model: {
                          value: _vm.colorLink,
                          callback: function callback($$v) {
                            _vm.colorLink = $$v
                          },
                          expression: "colorLink"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-item-group",
                    {
                      attrs: {
                        "active-class": "primary"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "4"
                              }
                            },
                            [
                              _vm._v(
                                " Please select a primary color for your theme. "
                              ),
                              _c("v-item", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function fn(_ref) {
                                      var active = _ref.active,
                                        toggle = _ref.toggle
                                      return [
                                        _c(
                                          "v-card",
                                          {
                                            staticClass:
                                              "app-card d-flex align-center",
                                            attrs: {
                                              height: "230",
                                              color: _vm.colorPrimary
                                            }
                                          },
                                          [
                                            _c(
                                              "v-card-text",
                                              {
                                                staticClass: "text-center"
                                              },
                                              [
                                                _c(
                                                  "gg-btn",
                                                  {
                                                    staticClass: "mt-5",
                                                    attrs: {
                                                      tile: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function click(
                                                        $event
                                                      ) {
                                                        return _vm.openColorPicker(
                                                          "dialogColorPrimary"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          active
                                                            ? "Selected"
                                                            : "Select"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "4"
                              }
                            },
                            [
                              _vm._v(
                                " Please select a secondary color for your theme. "
                              ),
                              _c("v-item", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function fn(_ref2) {
                                      var active = _ref2.active,
                                        toggle = _ref2.toggle
                                      return [
                                        _c(
                                          "v-card",
                                          {
                                            staticClass:
                                              "app-card d-flex align-center",
                                            attrs: {
                                              height: "230",
                                              color: _vm.colorSecondary
                                            }
                                          },
                                          [
                                            _c(
                                              "v-card-text",
                                              {
                                                staticClass: "text-center"
                                              },
                                              [
                                                _c(
                                                  "gg-btn",
                                                  {
                                                    staticClass: "mt-5",
                                                    attrs: {
                                                      tile: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function click(
                                                        $event
                                                      ) {
                                                        return _vm.openColorPicker(
                                                          "dialogColorSecondary"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          active
                                                            ? "Selected"
                                                            : "Select"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "4"
                              }
                            },
                            [
                              _vm._v(
                                " Please select a link color for your theme. "
                              ),
                              _c("v-item", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function fn(_ref3) {
                                      var active = _ref3.active,
                                        toggle = _ref3.toggle
                                      return [
                                        _c(
                                          "v-card",
                                          {
                                            staticClass:
                                              "app-card d-flex align-center",
                                            attrs: {
                                              height: "230",
                                              color: _vm.colorLink
                                            }
                                          },
                                          [
                                            _c(
                                              "v-card-text",
                                              {
                                                staticClass: "text-center"
                                              },
                                              [
                                                _c(
                                                  "gg-btn",
                                                  {
                                                    staticClass: "mt-5",
                                                    attrs: {
                                                      tile: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function click(
                                                        $event
                                                      ) {
                                                        return _vm.openColorPicker(
                                                          "dialogColorLink"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          active
                                                            ? "Selected"
                                                            : "Select"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }